import PropTypes from 'prop-types'
import React from 'react'

// Vendored from @tabler/icons-react (MIT, https://tabler.io/icons) so we
// don't carry the full library for a handful of icons
const IconClock = ({ className, color, size, strokeWidth }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
    <path d="M12 7v5l3 3" />
  </svg>
)

IconClock.defaultProps = {
  className: '',
  color: 'currentColor',
  size: 24,
  strokeWidth: 2,
}

IconClock.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
}

export default IconClock
